<template>
    <div class="pricing-box">
        <div class="pricing-content">
            <img src="@/assets/48x48.png" class="pricing-img" @click="offPricingButton">
            <div class="pricing-title">{{ $t('pricing.pricingTitle') }}</div>
            <div class="topButton-style">
                <div class="pricing-topButton">
                    <!-- 按月按钮 -->
                    <button @click="pricingMonthly"
                        :class="{ 'topButton-leftFucus': pricingIstrue, 'topButton-left': pricingIsfalse }">Monthly</button>
                    <!-- 按年按钮 -->
                    <button :class="{ 'topButton-rightFucus': pricingIsfalse, 'topButton-right': pricingIstrue }"
                        @click="pricingYearly">
                        Yearly
                        <span id="rightFreeStyle" :class="{'topButton-right-min': pricingIstrue}">(Get 2 month free)</span>
                    </button>
                </div>
                <div class="pricing-topButton-right" v-show="pricingIsfalse == true ? true : false">
                    <img src="@/assets/arrow.png">
                    Most popular!
                </div>
            </div>
            <div class='pricing-labelPage-box'>
                <!-- 第一个 -->
                <div id="pricingOne" class="pricing-labelPage-style">
                    <div class='labelPage-top'>
                        <div class='labelPage-word-top'>Free</div>
                        <div class='labelPage-word-middle'>{{ oneMoneyNumber }}</div>
                        <div class='labelPage-word-bottom'>Per month</div>
                    </div>
                    <div class="labelPage-middle">
                        <div class="labelPage-explain-top">
                            <img src="@/assets/24x24 yes.png">
                            Monthly Credit <span>40</span>
                        </div>
                        <div class="labelPage-explain-middle">
                            <img src="@/assets/24x24 yes.png">
                            Assets are private & customer owned
                        </div>
                        <div class="labelPage-explain-bottom">
                            <img src="@/assets/24x24 no.png">
                            API access
                        </div>
                    </div>
                    <button class="labelPage-button" @click="SubscribeNowClick">Try Now</button>
                </div>
                <!-- 第二个 -->
                <div id="pricingTow" class="pricing-labelPage-style">
                    <div class='labelPage-top'>
                        <div class='labelPage-word-top'>Free</div>
                        <div class='labelPage-word-middle'>{{ twoMoneyNumber }}</div>
                        <div class='labelPage-word-bottom'>Per month</div>
                    </div>
                    <div class="labelPage-middle">
                        <div class="labelPage-explain-top">
                            <img src="@/assets/24x24 yes.png">
                            Monthly Credit <span>40</span>
                        </div>
                        <div class="labelPage-explain-middle">
                            <img src="@/assets/24x24 yes.png">
                            Assets are private & customer owned
                        </div>
                        <div class="labelPage-explain-bottom">
                            <img src="@/assets/24x24 yes.png">
                            API access
                        </div>
                    </div>
                    <button class="labelPage-button" @click="SubscribeNowClick">Subscribe Now</button>
                </div>
                <!-- 第三个 -->
                <div id="pricingThree" class="pricing-labelPage-style">
                    <div class='labelPage-top'>
                        <div class='labelPage-word-top'>Free</div>
                        <div class='labelPage-word-middle'>{{ threeMoneyNumber }}</div>
                        <div class='labelPage-word-bottom'>Per month</div>
                    </div>
                    <div class="labelPage-middle">
                        <div class="labelPage-explain-top">
                            <img src="@/assets/24x24 yes.png">
                            Monthly Credit <span>40</span>
                        </div>
                        <div class="labelPage-explain-middle">
                            <img src="@/assets/24x24 yes.png">
                            Assets are private & customer owned
                        </div>
                        <div class="labelPage-explain-bottom">
                            <img src="@/assets/24x24 yes.png">
                            API access
                        </div>
                    </div>
                    <button class="labelPage-button" @click="SubscribeNowClick">Subscribe Now</button>
                </div>
            </div>
            <!-- 最下边 两框 -->
            <div class="footer-box">
                <div class="footer-fonts">
                    <div class="fonts-top">Enterprise</div>
                    <div class="fonts-bottom">For larger organizations with specific needs</div>
                </div>
                <button>Contact Us</button>
            </div>
            <div class="footer-box">
                <div class="footer-fonts">
                    <div class="fonts-one">We provide API Reference & Demo Code</div>
                </div>
                <button>Contact Us</button>
            </div>
        </div>
        <!-- 兑换弹窗 -->
        <ExchangeDrawer v-if="isExchangeDrawer" :offExchange="offExchange"></ExchangeDrawer>
    </div>
</template>

<script>
import { reactive, toRefs } from 'vue'
import { useRouter } from 'vue-router'
import ExchangeDrawer from './exchangeDrawer'
export default {
    name: 'Pricing',
    components:{
        ExchangeDrawer
    },
    props: {
        offPricingButton: {
            type: Function
        }
    },
    setup(props) {
        const router = useRouter()
        const state = reactive({
            oneMoneyNumber: '$0',
            twoMoneyNumber: '$20',
            threeMoneyNumber: '$50',
            pricingIsfalse: true,//定价弹窗按年，按月点击前后效果切换
            pricingIstrue: false, // 定价弹窗按年，按月点击前后效果切换
            isExchangeDrawer:false,// 兑换弹窗 false关，true开
        })
        // 关闭兑换组件弹窗
        function offExchange(){
            state.isExchangeDrawer = false
            offPricingButton()
        }
        // 关闭弹窗
        function offPricingButton() {
            props.offPricingButton()
        }
        /**
      * 定价 按月
      */
        function pricingMonthly() {
            state.pricingIsfalse = true
            state.pricingIstrue = false
            state.oneMoneyNumber = '$0'
            state.twoMoneyNumber = '$20'
            state.threeMoneyNumber = '$50'
        }
        /**
         * 定价 按年
         */
        function pricingYearly() {
            state.pricingIsfalse = false
            state.pricingIstrue = true
            state.oneMoneyNumber = '$0'
            state.twoMoneyNumber = '$200'
            state.threeMoneyNumber = '$500'
        }
        /**
         * 跳转收银台
         */
        function SubscribeNowClick() {
            // router.push('/cashierdesk')
            state.isExchangeDrawer = true
        }
        return {
            ...toRefs(state),
            offPricingButton,
            pricingMonthly,
            pricingYearly,
            SubscribeNowClick,
            offExchange
        }
    }
}
</script>

<style lang="scss" scoped>
//定价弹窗
.pricing-box {
    background: rgba(0, 0, 0, 0.6);
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    z-index: 30;
    & * {
        box-sizing: border-box;
    }

    .pricing-content {
        width: 8.91rem;
        height: 8.07rem;
        background: #ffffff;
        border-radius: 0.2rem;
        padding: 0.3rem;
        position: absolute;
        top: 1rem;
        left: 0rem;
        right: 0rem;
        margin: 0rem auto;
        box-sizing: border-box;
        z-index: 30;
        box-shadow: 0px 0.1rem 0.4rem -0.04rem rgba(0, 0, 0, 0.02);

        .pricing-img {
            width: 0.3rem;
            height: 0.3rem;
            position: absolute;
            right: 0.3rem;
            cursor: pointer;
        }

        .pricing-title {
            font-size: 0.3rem;
            font-family: Roboto, Roboto;
            font-weight: bold;
            color: #0E140F;
            text-align: center;
        }

        // 按年按月按钮
        .topButton-style {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 0.23rem;
            position: relative;

            .pricing-topButton {
                width: 3.51rem;
                height: 0.48rem;
                background: #F4F5F6;
                border-radius: 0.6rem;
                opacity: 1;
                display: flex;

                // 点击后效果 左边
                .topButton-left {
                    width: 1.2rem;
                    height: 0.48rem;
                    background: #0667CF;
                    border-radius: 0.6rem;
                    border: #0667CF;
                    opacity: 1;
                    font-size: 0.16rem;
                    font-family: interbureau, interbureau;
                    font-weight: bold;
                    color: #FFFFFF;
                    cursor: pointer;
                    display: block;
                }

                // 点击前效果 左边
                .topButton-leftFucus {
                    width: 1.2rem;
                    height: 0.48rem;
                    font-size: 0.16rem;
                    font-family: interbureau, interbureau;
                    font-weight: bold;
                    color: #000000;
                    border: none;
                    background: #F4F5F6;
                    border-radius: 0.6rem;
                    cursor: pointer;
                    display: block;
                }

                // 点击前效果 右边
                .topButton-rightFucus {
                    width: 2.30rem;
                    height: 0.48rem;
                    border-radius: 0.6rem;
                    font-size: 0.16rem;
                    font-family: interbureau, interbureau;
                    font-weight: bold;
                    color: #000000;
                    border: none;
                    background: #F4F5F6;
                    border-radius: 0.6rem;
                    cursor: pointer;
                    display: block;
                }

                // 点击后效果 右边
                .topButton-right {
                    width: 2.3rem;
                    height: 0.48rem;
                    background: #0667CF;
                    border-radius: 0.6rem;
                    opacity: 1;
                    border: #0667CF;
                    font-size: 0.16rem;
                    font-family: interbureau, interbureau;
                    font-weight: bold;
                    color: #FFFFFF;
                    display: block;
                    cursor: pointer;
                }
                .topButton-right-min{
                    color: #FFFFFF !important;
                }

                // 年 按钮里面小字
                #rightFreeStyle {
                    width: 1.23rem;
                    height: 0.2rem;
                    font-size: 0.14rem;
                    font-family: interbureau, interbureau;
                    font-weight: 400;
                    color: #333333;
                    cursor: pointer;
                }

            }

            .pricing-topButton-right {
                font-size: 0.12rem;
                font-family: interbureau, interbureau;
                font-weight: 500;
                color: #0E140F;
                // margin-left: 8px;
                position: absolute;
                left: 6.02rem;

                img {
                    width: 0.42rem;
                    height: 0.2rem;
                    position: absolute;
                    top: -0.15rem;
                    left: -0.34rem;
                }
            }
        }

        .pricing-labelPage-box {
            margin-top: 0.23rem;
            display: flex;

            // 单独加样式
            #pricingOne {
                border: 0.01rem solid rgba(0, 0, 0, 0.15);
                border-radius: 0.2rem 0rem 0rem 0.2rem;
            }

            #pricingTow {
                border-top: 0.01rem solid rgba(0, 0, 0, 0.15);
                // border-right:1px solid rgba(0, 0, 0, 0.15);
                border-bottom: 0.01rem solid rgba(0, 0, 0, 0.15);

                .labelPage-top {
                    border-radius: 0rem;
                }
            }

            #pricingThree {
                border: 0.01rem solid rgba(0, 0, 0, 0.15);
                border-radius: 0 0.2rem 0.2rem 0;

                .labelPage-top {
                    border-radius: 0rem 0.2rem 0rem 0rem;
                }
            }

            .pricing-labelPage-style {
                width: 2.77rem;
                height: 4.1rem;
                background: #FFFFFF;
                opacity: 1;
                // border: 1px solid rgba(0, 0, 0, 0.15);

                .labelPage-top {
                    height: 1.68rem;
                    border-radius: 0.2rem 0rem 0rem 0rem;
                    // opacity: 0.05;
                    border: 0.01rem solid rgba(0, 0, 0, 0.15);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;
                    background: rgba(0, 0, 0, 0.05);

                    .labelPage-word-top {
                        font-size: 0.2rem;
                        font-family: interbureau, interbureau;
                        font-weight: normal;
                        color: #3B3A40;
                        margin-bottom: 0.1rem;
                    }

                    .labelPage-word-middle {
                        font-size: 0.36rem;
                        font-family: interbureau, interbureau;
                        font-weight: normal;
                        color: #000000;
                        margin-bottom: 0.1rem;
                    }

                    .labelPage-word-bottom {
                        font-size: 0.12rem;
                        font-family: interbureau, interbureau;
                        font-weight: 400;
                        color: #64626A;
                    }

                }

                .labelPage-middle {
                    padding: 0.2rem 0.15rem 0 0.15rem;
                    box-sizing: border-box;
                    display: flex;
                    flex-direction: column;

                    .labelPage-explain-top {
                        font-size: 0.12rem;
                        font-family: interbureau, interbureau;
                        font-weight: 400;
                        color: #3B3A40;
                        margin-bottom: 0.24rem;
                        // display: flex;
                        // margin-left: 20px;
                        line-height: 0.24rem;

                        span {
                            color: #0667CF;
                        }

                        img {
                            width: 0.24rem;
                            height: 0.24rem;
                            float: left;
                            margin-right: 0.07rem;
                        }
                    }

                    .labelPage-explain-top::after {
                        display: block;
                        content: '';
                        clear: both;
                    }

                    .labelPage-explain-middle {
                        font-size: 0.12rem;
                        font-family: interbureau, interbureau;
                        font-weight: 400;
                        color: #3B3A40;
                        margin-bottom: 0.24rem;
                        line-height: 0.24rem;

                        img {
                            width: 0.24rem;
                            height: 0.24rem;
                            float: left;
                            margin-right: 0.05rem;
                        }
                    }

                    .labelPage-explain-middle::after {
                        display: block;
                        content: '';
                        clear: both;
                    }

                    .labelPage-explain-bottom {
                        font-size: 0.12rem;
                        font-family: interbureau, interbureau;
                        font-weight: 400;
                        color: #3B3A40;
                        line-height: 0.24rem;

                        img {
                            width: 0.24rem;
                            height: 0.24rem;
                            float: left;
                            margin-right: 0.07rem;
                        }
                    }

                    .labelPage-explain-bottom::after {
                        display: block;
                        content: '';
                        clear: both;
                    }
                }

                .labelPage-button {
                    width: 1.8rem;
                    height: 0.48rem;
                    background: #0667CF;
                    border-radius: 0.6rem;
                    opacity: 1;
                    font-size: 0.14rem;
                    font-family: interbureau, interbureau;
                    font-weight: bold;
                    color: #FFFFFF;
                    border: #0667CF;
                    margin: 0.3rem 0.48rem 0.32rem 0.49rem;
                    display: block;
                    cursor: pointer;
                }
            }
        }

        .footer-box {
            height: 0.94rem;
            background: #F3F7FD;
            border-radius: 0.2rem;
            opacity: 1;
            border: 0.01rem solid rgba(0, 0, 0, 0.15);
            margin-top: 0.1rem;
            padding: 0.3rem;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .fonts-top {
                font-size: 0.2rem;
                font-family: interbureau, interbureau;
                font-weight: normal;
                color: #3B3A40;
            }

            .fonts-bottom {
                font-size: 0.12rem;
                font-family: interbureau, interbureau;
                font-weight: 400;
                color: #64626A;
                margin-top: 0.1rem;
            }

            button {
                width: 1.2rem;
                height: 0.48rem;
                border-radius: 0.37rem;
                opacity: 1;
                border: 0.02rem solid #0667CF;
                font-size: 0.16rem;
                font-family: PingFang SC, PingFang SC;
                font-weight: 600;
                color: #0667CF;
                background: #F3F7FD;
            }

            .fonts-one {
                font-size: 0.16rem;
                font-family: interbureau, interbureau;
                font-weight: 400;
                color: #64626A;
            }
        }
    }


}
</style>